import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";

const mapProductModel = (
    product: ProductModel,
    options?: Toolkit.GoogleAnalytics.Options,
): Toolkit.GoogleAnalytics.Item => {
    const { brand, id, isDiscontinued, productNumber, productTitle } = product;

    return {
        discontinued: isDiscontinued || undefined,
        item_brand: brand?.name || undefined,
        item_id: productNumber,
        item_name: productTitle,
        price: ga.util.parseAmount(product.unitListPrice),
        ...ga.map.productInfosOption(options, id),
        ...options?.itemData,
    };
};

export default mapProductModel;
